const LIST_CACHE_TTL_MS = 1500;

type CacheEntry = {
  promise: Promise<unknown>;
  expiresAt: number;
};

const listCache = new Map<string, CacheEntry>();

export function clearFacilityNetworkListCache(): void {
  listCache.clear();
}

/** Share in-flight (and briefly cached) list GETs across page + inbox + Strict Mode remount. */
export function coalesceFacilityNetworkList<T>(
  key: string,
  load: () => Promise<T>,
): Promise<T> {
  const now = Date.now();
  const hit = listCache.get(key);
  if (hit && hit.expiresAt > now) {
    return hit.promise as Promise<T>;
  }
  const promise = load();
  listCache.set(key, { promise, expiresAt: now + LIST_CACHE_TTL_MS });
  return promise;
}

export function isEmptyFacilityNetworkListStatus(status: number): boolean {
  return status === 404;
}

export function isFacilityNetworkNotFoundMessage(message: string): boolean {
  const normalized = message.trim().toLowerCase();
  return (
    normalized === "not found" ||
    normalized.includes("status 404") ||
    /failed with status 404/.test(normalized)
  );
}
